import React from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Table, {IColumn} from 'shared/ui/Table/Table';
import {IPortCheckResult} from 'features/port/model/PortMonitor/IPortMonitor';
import {getLocationCityName} from 'features/port/model/PortMonitor/getLocationCityName';
import {getPortCheckDesiredLabel, getPortCheckStatusLabel} from 'features/port/lib/portMonitorHelper';

import styles from './PortCheckResultsTable.module.scss';

interface IPortCheckResultsTableProps {
    results: IPortCheckResult[],
    emptyText: string,
    isLoading?: boolean,
    className?: string,
}

const PortCheckResultsTable: React.FC<IPortCheckResultsTableProps> = ({
    results,
    emptyText,
    isLoading = false,
    className,
}) => {
    const columns: IColumn[] = [
        {label: t`Локация`},
        {label: t`Результат`},
        {label: t`Совпадает с желаемым`},
        {label: t`Время`},
    ];

    const isEmptyList = !isLoading && results.length === 0;

    return (
        <div className={cn(styles.wrapper, className)}>
            <Table
                columns={columns}
                items={results}
                isLoading={isLoading}
                rowFactory={(result) => (
                    <tr key={result.id}>
                        <td>
                            <div className={styles.location}>
                                {[result.country, getLocationCityName(result.city)].filter(Boolean).join(', ')}
                            </div>
                            {result.name && <div className={styles.secondary}>{result.name}</div>}
                            {!result.selected_by_user && (
                                <div className={styles.secondary}>{t`Локация по умолчанию`}</div>
                            )}
                        </td>
                        <td>
                            <div>{getPortCheckStatusLabel(result.status)}</div>
                            {result.status === 'unknown' && result.message && (
                                <div className={styles.secondary}>{result.message}</div>
                            )}
                        </td>
                        <td>{getPortCheckDesiredLabel(result.is_desired)}</td>
                        <td className={styles.timeCell}>{result.time} {t`мс`}</td>
                    </tr>
                )}
                emptyStateComponent
            />

            {isEmptyList && <div className={styles.empty}>{emptyText}</div>}
        </div>
    );
};

export default PortCheckResultsTable;
